import { showAlert } from '../components/general-ui/alert/alert-service';
import { toggleFeatureFlag } from '../store/actions/feature-flags';
import store from '../store/main';
import featureFlagKeyMap from './feature-flag-keymap';

const isProd = process.env.REACT_APP_STAGE === 'prod';

const onoff = (isOn: boolean) => isOn ? 'on' : 'off';

class FeatureFlagTool {
	constructor() {
		window.addEventListener('keyup', this.handleKeyUp);
	}

	handleKeyUp = (e: KeyboardEvent) => {
		// must press (alt or option)+shift
		if (e.altKey && e.shiftKey && !isProd) {
			const val = featureFlagKeyMap[e.code];

			if (val) {
				const prevValue = store.getState().FeatureFlagsReducer.featureFlags[val];

				if (typeof prevValue !== 'undefined' || val.startsWith('test')) {
					store.dispatch(toggleFeatureFlag(val));
					showAlert({
						message: 'Toggled flag',
						description: `${val} to ${onoff(!prevValue)}`,
						type: 'warning'
					});
				}
			}
		}
	};
}

export default new FeatureFlagTool();
